export default "__VITE_ASSET__DEj85Isx__"